module.exports = __webpack_public_path__ + "static/media/BG-02.244a967c.jpg";